import { Container } from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { useAuth } from 'react-oidc-context';
import Page from '../Page';

function GlobalFallbackComponent({
  error,
  Logo,
  ERROR_PAGE_TYPE,
  getErrorMessage,
  ErrorDisplay,
  useLocalization,
  Footer,
}) {
  const { signinRedirect } = useAuth();
  const { formatMessage } = useLocalization();
  return (
    <div>
      <Page>
        <Container
          sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
          }}>
          <Grid2 container>
            <Grid2 xs={12} sx={{ mt: 3 }}>
              <Logo href="/" />
            </Grid2>
            <Grid2 xs={12}>
              <ErrorDisplay
                {...getErrorMessage({
                  type: ERROR_PAGE_TYPE.CODE_ERROR,
                  loginAction: () => {
                    if (signinRedirect) {
                      signinRedirect();
                    } else {
                      window.location.href = '/';
                    }
                  },
                  errors: { codeErrors: { message: error?.message } },
                  formatMessage,
                })}
              />
            </Grid2>
          </Grid2>
        </Container>
        <Container>
          <Footer maxWidth="xl" />
        </Container>
      </Page>
    </div>
  );
}

export default GlobalFallbackComponent;
